import React from "react";
import { useGet } from "../../common/hooks";
import { useEnsuredUser } from "../../common/contexts";
import { Game } from "../../common/interfaces";
import { dtNow } from "../../common/utils";
import _ from "lodash";
import { Divider } from "antd";
import { AttendanceTable } from "../../common/components/AttendanceTable";

export function GoalieSchedule() {
  const user = useEnsuredUser();
  const games = useGet<Game[]>(`/api/games?goalieId=${user.goalieId}`);

  const partitionGames = (games: Game[]): { upcoming: Game[]; past: Game[] } => {
    const now = dtNow();
    const [past, upcoming] = _.partition(games, g => g.date < now);
    return {
      upcoming: _.sortBy(upcoming, g => g.date),
      past: _.sortBy(past, g => g.date).reverse()
    };
  };

  const partition = partitionGames(games.data || []);

  return (
    <>
      <Divider>Upcoming Games</Divider>
      <AttendanceTable
        games={games.data ? partition.upcoming : undefined}
        isLoading={games.isLoading}
        showAttendanceButtons={false}
        onClick={() => undefined}
      />
      <Divider>Past Games</Divider>
      <AttendanceTable
        games={games.data ? partition.past : undefined}
        isLoading={games.isLoading}
        showAttendanceButtons={false}
        onClick={() => undefined}
      />
    </>
  );
}
